(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("NavMenu", ["jquery"], factory);
    } else {
        // Browser globals
        root.siteheader = factory(root.jQuery, root.betteroffcanvas);
    }
}(this, function ($) {
    "use strict";

    $('.fl-module-button').each(function () {
        var $this = $(this);

        if ($this.attr('id')) {
            $this.find('.fl-button').attr('id', $this.attr('id'));
            $this.attr('id', '');
        }
    });
}));